import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiContactMethod, ApiContactResponse } from './api-contact.models';

import { ContactForm } from '@api/contact/models/contact.models';
import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiContactService {
    constructor(private readonly http: HttpClient, private readonly apiRequestService: HttpRequestsService) {}

    public sendContactForm(storeId: string, languageId: string, body: ContactForm): Observable<ApiContactResponse> {
        const slug = `user/store/${storeId}/contact`;
        const url = this.apiRequestService.requestUrl(slug, languageId);
        return this.http.post<any>(url, body);
    }

    public getContactMethod(storeId: string, languageId: string): Observable<ApiContactMethod> {
        const slug = `oam/store/${storeId}/contact-method`;
        const url = this.apiRequestService.requestUrl(slug, languageId, null, true, '1');

        return this.http.get<ApiContactMethod>(url);
    }

    // TODO ECOMDUTI-20990 [TechDebt] - cambiar a que devuelva un observable con algo
    public setContactMethod(data: number, storeId: string, languageId: string) {
        const slug = `user/store/${storeId}/contact-method`;
        const url = this.apiRequestService.requestUrl(slug, languageId, null, true);

        return this.http.put<any>(url, {
            captchaId: '',
            captchaValue: '',
            contactMethod: data,
        });
    }
}
